import styled from 'styled-components';

import { Button } from '@atom/button/button';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ConnectorTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const WrapperCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SaveButton = styled(Button)`
  width: 100px;
`;

export const Description = styled(Text).attrs({
  level: 'm',
  paragraph: true,
})`
  padding-top: 16px;
  width: 60%;
  min-width: 600px;
`;

export const DescriptionReadMore = styled.div`
  margin-top: 16px;
`;

export const WrapperEndpoint = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;
  padding: 24px 0 0 0;
`;

export const UserAgentDescription = styled.div`
  margin-bottom: 20px;
  padding: 16px;
  background-color: ${ColorEnum.MonochromesCloud};
  border-radius: 8px;
  border-left: 4px solid ${ColorEnum.Teal100};
`;

export const UserAgentTitle = styled.div`
  margin-bottom: 4px;
`;

export const UserAgentFormat = styled.div`
  margin-bottom: 6px;
  padding: 4px 6px;
  background-color: ${ColorEnum.White};
  border-radius: 4px;
  border: 1px solid ${ColorEnum.Black20};
`;

export const UserAgentExample = styled.div`
  margin-top: 6px;
`;

export const UserAgentCode = styled.div`
  margin: 3px 0;
  padding: 4px 6px;
  background-color: ${ColorEnum.Black3};
  border-radius: 4px;
  border: 1px solid ${ColorEnum.Black10};
`;

export const UserAgentNote = styled.div`
  margin-top: 4px;
  font-style: italic;
  color: ${ColorEnum.Black80};
`;

export const UserAgentAttributes = styled.div`
  margin: 8px 0;
`;

export const UserAgentAttribute = styled.div`
  margin-bottom: 6px;
  padding: 4px 0;
  border-bottom: 1px solid ${ColorEnum.Black10};

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const UserAgentAttributeName = styled.div`
  margin-bottom: 2px;
  color: ${ColorEnum.Teal100};
`;

export const UserAgentAttributeDesc = styled.div`
  color: ${ColorEnum.Black80};
  line-height: 1.4;
`;
